const APPLIED_TYPE = {
  all: 'Toàn trường',
  grade: 'Theo khối',
  'grade-department': 'Theo khối + cơ sở',
  'grade-department-status': 'Theo khối + cơ sở + trạng thái khai hồ sơ'
}

const APPLIED_TYPE_SELECT_ITEMS = [
  {title: 'Toàn trường', value: 'all'},
  {title: 'Theo khối', value: 'grade'},
  {title: 'Theo khối + cơ sở', value: 'grade-department'},
  {title: 'Theo khối + cơ sở + trạng thái khai hồ sơ', value: 'grade-department-status'}
  // { title: 'Đối tượng cụ thể', value: 'custom' }
]

const TYPE = {
  'enroll-slot': 'Đăng ký ca thi',
  'school-tour': 'Tham quan trường'
}

const EVENT_TABLE_HEADERS = [
  {text: 'Tiêu đề', value: 'title'},
  {text: 'Thời gian diễn ra', value: 'fromTo'},
  {text: 'Loại', value: 'type', align: 'center'},
  {text: 'T.Thái hiển thị', value: 'isPublished', align: 'center'},
  {text: 'T.Thái đăng ký', value: 'isOpenRegistration', align: 'center'},
  {text: 'T.Thái hết hạn', value: 'isExpired', align: 'center'},
  {text: 'Đối tượng áp dụng', value: 'appliedType', align: 'center'},
  {text: 'Thao tác', align: 'end', value: 'actions'}
]

export default {EVENT_TABLE_HEADERS, APPLIED_TYPE, APPLIED_TYPE_SELECT_ITEMS, TYPE}
